// extracted by mini-css-extract-plugin
export default {"mainWrapper":"AuthorizedSignatures_mainWrapper__AmZuz"};